import { useState, useRef, useLayoutEffect } from "react"
import PropTypes from "prop-types"
import { isEmpty } from "lodash"
import { IconButton, CircularProgress } from "@mui/material"
import { CloudDownload } from "@mui/icons-material"
import { downloadXlsx } from "helpers/csv"
import { connect } from "react-redux"
import { Creators as NotificationCreators } from "modules/notifications/model"
import Tooltip from "components/material/tooltip"

import "./styles.scss"
import classNames from "classnames"

function ExcelDownload({ data, fileName, dispatch, type, track, title = "Download as XLSX", location, enterDelay = 300, icon, className, ...props }) {
  const buttonRef = useRef()
  const [loading, setLoading] = useState(false)

  const [dimensions, setDimensions] = useState({ width: 0, height: 0 })

  useLayoutEffect(() => {
    if (buttonRef.current) {
      setDimensions({
        width: buttonRef.current.offsetWidth,
        height: buttonRef.current.offsetHeight,
      })
    }
  }, [])

  const download = async () => {
    setLoading(true)
    const success = await downloadXlsx(fileName, data, { type, location, track })
    if (!success) {
      dispatch(NotificationCreators.add("error", null, "There was a problem while generating the file. Please try again"))
    }
    setLoading(false)
  }

  return <div className={classNames("excel-download", className || "")}>
    <Tooltip enterDelay={enterDelay} title={title}>
      <span>
        {loading && <CircularProgress size={dimensions.width} />}
        <IconButton
          ref={buttonRef}
          disabled={loading || isEmpty(data)}
          {...props}
          onClick={download}
          size="large"
        >
          {icon || <CloudDownload />}
        </IconButton>
      </span>
    </Tooltip>
  </div>
}

ExcelDownload.propTypes = {
  id: PropTypes.string,
  data: PropTypes.array.isRequired,
  fileName: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  type: PropTypes.string,
  track: PropTypes.func,
  title: PropTypes.string,
  location: PropTypes.string,
  enterDelay: PropTypes.number,
  icon: PropTypes.element,
  className: PropTypes.string,
}

export default connect(null, (dispatch) => ({ dispatch }))(ExcelDownload)
